/**
查询过滤器
通常用在 list 页面中，但其本身功能是完整的。
可以迁移到任何页面中，只要配置完善了 store 和对应的 model。
使用方法可以参考 '@/components/MesListPage.vue'
 */
<template>
  <div class="row">
    <div class="form-group col-md-2" v-for="col in tableColumns" v-bind:key="col.key">
      <label class="control-label">{{ $t(col.label) }}:</label>
      <mmf-form-helper
        is-editing
        :metadata="col"
        :value="filter[col.key]"
        @input="changeFilterAttribute(col, $event)"
      />
    </div>
    <div class="col-lg-3 align-self-end">
      <div class="float-lg-right">
        <button
          class="btn btn-outline-secondary mr-1"
          type="button"
          v-on:click="MMFClearFilter(entity)"
        >
          <i class="fa fa-fw fa-lg fa-eraser"></i>
          <span class="text">{{ $t("btn.basic.clear") }}</span>
        </button>
        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows(entity)">
          <i class="fa fa-fw fa-lg fa-search"></i>
          <span class="text">{{ $t("btn.basic.search") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import MmfFormHelper from "@/components/MmfFormHelper";
import model from "@/model/index";
import { mapActions } from "vuex";

export default {
  name: "mmf-filter",
  data() {
    return {};
  },
  components: { MmfFormHelper },
  props: {
    entity: String
  },
  computed: {
    tableColumns() {
      return model[this.entity].filterConfigs;
    },
    filter: {
      get() {
        var result = this.$store.state[this.entity].filter;
        return result;
      }
    }
  },
  methods: {
    changeFilterAttribute(col, $event) {
      this.$store.commit(this.entity + "/setFilterAttribute", {
        key: col.key,
        newValue: $event
      });
      if (col.form.type === "entitySelect") {
        var id = $event ? $event : 0;
        if (col.form.onChangeDispatchAction) {
          for (var i in col.form.onChangeDispatchAction) {
            this.$store.dispatch(col.form.onChangeDispatchAction[i], {
              id,
              mainEntity: this.entity,
              type: "filter"
            });
          }
        }
      }
    },
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"])
  }
};
</script>
